!function(global) {
  'use strict';

  var previouscallViewErrorHandler = global.ViewErrorHandler;

  function ViewErrorHandler(options) {
    var options = options || {};
    var container;

    function init() {
      container = options.container;
    }

    function hideMessages() {
      container.empty();
    }

    function showInfo(message) {
      var messageDiv = '<div class="alert alert-info alert-dismissable ">'
                      //+ '<button type="button" class="close" data-dismiss="alert">&times;</button>'
                      + '<h3>Info</h3>'
                      + '<p>'
                      + message
                      + '</p>'
                      + '</div>';
      container.empty();
      container.append(messageDiv);
    }

    function showWarning(message) {
      var messageDiv  = '<div class="alert alert-warning alert-dismissable ">'
                      //+ '<button type="button" class="close" data-dismiss="alert">&times;</button>'
                      + '<h3>Lo sentimos pero...</h3>'
                      + '<p>'
                      + message
                      + '</p>'
                      + '</div>';
      container.empty();
      container.append(messageDiv);
    }

    init();

    return {
      showInfo: showInfo,
      showWarning: showWarning,
      hideMessages: hideMessages
    }

  }

  ViewErrorHandler.noConflict = function noConflict() {
    global.ViewErrorHandler = previouscallViewErrorHandler;
    return ViewErrorHandler;
  };

  global.ViewErrorHandler = ViewErrorHandler;
}(this);
